// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.App {
  height: calc(var(--vh, 1vh) * 100);
  text-align: center;
  min-width: 650px;
  width: 100%;
  /* display: flex;
  align-items: center;
  justify-content: center; */
}

/* signForm */

.signForm_page{
  padding-top: calc(var(--vh, 1vh) * 10);
  min-height: calc(var(--vh, 1vh) * 90);
  background-color: rgba(159, 203, 243, 0.4);
  /* background-color: lightgrey; */
}
.signForm_div{
  background-color: white;
  min-width: 350px;
  max-width: 500px;
  width: 45%;
  height: 400px;
  margin: 0 auto 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  border-radius: 25px;
  box-shadow: 2px 2px 4px rgb(19, 93, 158);
}
.signForm_header{
  font-size: 40px;
  margin: 0;
  color: rgb(19, 93, 158);
  text-shadow: 2px 2px 4px rgb(159, 203, 243);
}
.signForm_inputs{
  width: 70%;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
.signForm_input{
  height: 35px;
  font-size: 18px;
  text-indent: 10px;
}
.signForm_btn{
  width: 150px;
  height: 30px;
  font-size: 18px;
  font-weight: bold;
  background-color: rgb(19, 93, 158);
  color: white;
  border: none;
  border-radius: 14px;
  cursor: pointer;
}
.signForm_btn:hover{
  background-color: white;
  color: rgb(159, 203, 243);
  border: 0.5px solid rgb(159, 203, 243);
  box-shadow: 2px 2px 4px grey;
}
.signForm_linkDiv{
  font-size: 20px;
}
.signForm_link_a{
  text-decoration: none;
  color: rgb(19, 93, 158);
  font-weight: bold;
}
.signForm_link_a:hover{
  color: rgb(116, 180, 240);
  font-weight: bold;
}

@media (max-width: 650px){
  .App{
    /* background-color: red; */
    min-width: 400px;
  }
  .signForm_div{
    min-width: 300px;
    min-width: 30vw;
    max-width: 450px;
    width: 90%;
    min-height: 400px;
    height: 70vh;
    /* height: calc(var(--vh, 1vh) * 70); */
  }
  .signForm_header{
    font-size: 50px;
  }
  .signForm_btn{
    width: 200px;
    height: 50px;
    font-size: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":";AACA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX;;4BAE0B;AAC5B;;AAEA,aAAa;;AAEb;EACE,sCAAsC;EACtC,qCAAqC;EACrC,0CAA0C;EAC1C,iCAAiC;AACnC;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,2CAA2C;AAC7C;AACA;EACE,UAAU;EACV,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,sCAAsC;EACtC,4BAA4B;AAC9B;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE;IACE,2BAA2B;IAC3B,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,YAAY;IACZ,uCAAuC;EACzC;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":["\n.App {\n  height: calc(var(--vh, 1vh) * 100);\n  text-align: center;\n  min-width: 650px;\n  width: 100%;\n  /* display: flex;\n  align-items: center;\n  justify-content: center; */\n}\n\n/* signForm */\n\n.signForm_page{\n  padding-top: calc(var(--vh, 1vh) * 10);\n  min-height: calc(var(--vh, 1vh) * 90);\n  background-color: rgba(159, 203, 243, 0.4);\n  /* background-color: lightgrey; */\n}\n.signForm_div{\n  background-color: white;\n  min-width: 350px;\n  max-width: 500px;\n  width: 45%;\n  height: 400px;\n  margin: 0 auto 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-evenly;\n  border-radius: 25px;\n  box-shadow: 2px 2px 4px rgb(19, 93, 158);\n}\n.signForm_header{\n  font-size: 40px;\n  margin: 0;\n  color: rgb(19, 93, 158);\n  text-shadow: 2px 2px 4px rgb(159, 203, 243);\n}\n.signForm_inputs{\n  width: 70%;\n  height: 100px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n}\n.signForm_input{\n  height: 35px;\n  font-size: 18px;\n  text-indent: 10px;\n}\n.signForm_btn{\n  width: 150px;\n  height: 30px;\n  font-size: 18px;\n  font-weight: bold;\n  background-color: rgb(19, 93, 158);\n  color: white;\n  border: none;\n  border-radius: 14px;\n  cursor: pointer;\n}\n.signForm_btn:hover{\n  background-color: white;\n  color: rgb(159, 203, 243);\n  border: 0.5px solid rgb(159, 203, 243);\n  box-shadow: 2px 2px 4px grey;\n}\n.signForm_linkDiv{\n  font-size: 20px;\n}\n.signForm_link_a{\n  text-decoration: none;\n  color: rgb(19, 93, 158);\n  font-weight: bold;\n}\n.signForm_link_a:hover{\n  color: rgb(116, 180, 240);\n  font-weight: bold;\n}\n\n@media (max-width: 650px){\n  .App{\n    /* background-color: red; */\n    min-width: 400px;\n  }\n  .signForm_div{\n    min-width: 300px;\n    min-width: 30vw;\n    max-width: 450px;\n    width: 90%;\n    min-height: 400px;\n    height: 70vh;\n    /* height: calc(var(--vh, 1vh) * 70); */\n  }\n  .signForm_header{\n    font-size: 50px;\n  }\n  .signForm_btn{\n    width: 200px;\n    height: 50px;\n    font-size: 24px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
